<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/profile.jpg');background-size: 100%;background-position: top;">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Order Details</h1>
                        <p>"Welcome to your account! Edit your profile information!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="orderDetails-section mt-5 mb-5">
    <div class="container">
        <div class="address-container" *ngIf="!isLoading && orderDetails">
            <h3 class="section-title text-center">Order Details #{{orderDetails.orderId}}</h3>
            
            <!-- Vendor Info -->
            <div class="vendor-card">
                <img src="../../../../assets/img/logo.png" 
                     class="vendor-avatar">
                <div class="vendor-info">
                    <h4>BAYONNE BBQ & WINGS</h4>
                    <!-- <div class="order-status status-ordered">
                        {{ 'ordered' | titlecase }}
                    </div> -->
                    <div class="order-status" [ngClass]="{
                        'status-ordered': orderDetails?.status != 'canceled',
                        'status-canceled': orderDetails?.status === 'canceled',
                        'status-success': orderDetails?.status === 'accepted'
                    }">
                        {{ orderDetails?.status | titlecase }}
                    </div>
                </div>
            </div>

            <!-- Order Summary -->
            <div class="order-summary">
                <div class="summary-item">
                    <span class="summary-label">Order Date:</span>
                    <span class="summary-value">{{ orderDetails.orderedAt | date:'dd/MM/yyyy' }}</span>
                </div>

                <div class="summary-item">
                    <span class="summary-label">Order Time:</span>
                    <span class="summary-value">{{ orderDetails.orderedAt | date:'hh:mm a' }}</span>
                </div>

                <div class="summary-item">
                    <span class="summary-label">Delivery Time:</span>
                    <span class="summary-value" *ngIf="orderDetails.deliveryTime && orderDetails.deliveryTime != null">{{ orderDetails.deliveryTime +' min' }}</span>
                    <span class="summary-value" *ngIf="!orderDetails.deliveryTime || orderDetails.deliveryTime == null">Not Specified Yet</span>
                </div>
                
                <div class="summary-item">
                    <span class="summary-label">Delivery Address:</span>
                    <span class="summary-value">{{ orderDetails.address }}</span>
                </div>
                
                <div class="summary-item">
                    <span class="summary-label">Payment Method:</span>
                    <span class="summary-value">{{ orderDetails.paymentMethod }}</span>
                </div>
                
                <div class="summary-item">
                    <span class="summary-label">Notes:</span>
                    <span class="summary-value">{{  orderDetails.deliveryNote || '-' }}</span>
                </div>
            </div>

            <!-- Products List -->
            <div class="products-list">
                <p>
                    <span class="list-title">Products</span>
                </p>
                <div class="product-item row mb-3" *ngFor="let product of orderDetails.products; let i = index">
                    <div class="product-info col-md-4 col-sm-6">
                        <div class="d-flex align-items-center">
                            <img [src]="product.avatar" class="product-image me-3" alt="Product" style="width: 60px; height: 60px; object-fit: cover;">
                            <div class="product-info">
                                <h5 class="mb-1">{{product.name}}</h5>
                                <small class="text-muted">{{product.type | titlecase}}</small>
                                
                                <!-- Display Extras -->
                                <div *ngIf="hasExtras(product)" class="mt-1">
                                    <div *ngFor="let extra of product.extras" class="extra-item">
                                        <small class="text-muted">+ {{extra.name}} 
                                            <span *ngIf="extra.quantity > 1">({{extra.quantity}}x)</span>
                                            {{(extra.price * (extra.quantity || 1) * product.quantity) | currency:'USD':'symbol':'1.2-2'}}
                                            <span *ngIf="product.quantity > 1">({{product.quantity}}×)</span>
                                        </small>
                                    </div>
                                </div>
                                
                                <!-- Display Sides -->
                                <div *ngIf="hasSides(product)" class="mt-1">
                                    <div *ngFor="let side of product.sides" class="side-item">
                                        <small class="text-muted">+ {{side.name}} 
                                            <span *ngIf="side.quantity > 1">({{side.quantity}}x)</span>
                                            {{(side.price * (side.quantity || 1) * product.quantity) | currency:'USD':'symbol':'1.2-2'}}
                                            <span *ngIf="product.quantity > 1">({{product.quantity}}×)</span>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="product-quantity text-center col-md-4 col-sm-3">
                        <div class="mb-1">{{product.quantity}} × {{roundToNearestTen(product.price) | currency:'USD':'symbol':'1.2-2'}}</div>
                        
                        <!-- Show extras breakdown if any -->
                        <div *ngIf="hasExtras(product)" class="breakdown">
                            <small class="text-muted">
                                + Extras: {{calculateExtrasTotal(product.extras, product.quantity) | currency:'USD':'symbol':'1.2-2'}}
                            </small>
                        </div>
                        
                        <!-- Show sides breakdown if any -->
                        <div *ngIf="hasSides(product)" class="breakdown">
                            <small class="text-muted">
                                + Sides: {{calculateSidesTotal(product.sides, product.quantity) | currency:'USD':'symbol':'1.2-2'}}
                            </small>
                        </div>
                    </div>
                    
                    <div class="product-total text-center col-md-4 col-sm-3">
                        <strong>{{calculateProductTotal(product) | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </div>
                </div>
            </div>

            <!-- Order Total -->
            <div class="order-total mt-4">
                <div class="total-row d-flex justify-content-between py-2">
                    <span>Subtotal</span>
                    <span>
                        {{ calculateSubtotal() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Delivery Fee -->
                <div class="total-row d-flex justify-content-between py-2" *ngIf="orderDetails.deliveryCost">
                    <span>Delivery fee</span>
                    <span>
                        {{ getRoundedDeliveryCost() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Service Fee/Tax -->
                <div class="total-row d-flex justify-content-between py-2" *ngIf="orderDetails.serviceCost">
                    <span>Service fee</span>
                    <span>
                        {{ getRoundedServiceCost() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Tips (will be added later) -->
                <div class="total-row d-flex justify-content-between py-2" *ngIf="orderTips">
                    <span>Tips</span>
                    <span>
                        {{ getRoundedTips() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Grand Total -->
                <div class="total-row d-flex justify-content-between py-2 mt-3" style="border-top: 1px solid #b6b6b6;">
                    <span><strong>Total</strong></span>
                    <span>
                        <strong>{{ calculateTotal() | currency:'USD':'symbol':'1.2-2' }}</strong>
                    </span>
                </div>
            </div>

        </div>
        <div class="address-container text-center" *ngIf="isLoading">
            <div class="spinner-grow" role="status" *ngIf="isLoading">
                <span class="visually-hidden">Loading...</span>
            </div>
            <!-- <div class="alert alert-danger" *ngIf="!orderDetails">
                <strong>Oops!</strong> Something went wrong!
            </div> -->
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>